module.exports = __webpack_public_path__ + "img/disgust.f7ad41b6.svg";